package com.xtream.data_kmp.dto


import androidx.room3.Entity
import androidx.room3.Ignore
import androidx.room3.PrimaryKey
import kotlinx.serialization.SerialName
import kotlinx.serialization.Transient


/*
 {
      "adult": false,
      "backdrop_path": "/Q2OajDi2kcO6yErb1IAyVDTKMs.jpg",
      "id": 1078605,
      "title": "Weapons",
      "overview": "When all but one child from the same class mysteriously vanish on the same night at exactly the same time, a community is left questioning who or what is behind their disappearance.",

      "popularity": 121.3396,
      "release_date": "2025-08-04",
      "vote_average": 7.5,
 */
// 1. Shared interface, no serialization here

interface BaseTrending: BaseStream {
    val adult: Boolean
    val backdrop: String?
    val id: Int
    val overview: String
    val popularity: Float?
    val releaseDate: String
    val voteAverage: Double?
}

// 2. TrendingMovie has its own serialization
@kotlinx.serialization.Serializable
@Entity(tableName = "TrendingMovies")

data class TrendingMovie(
    @SerialName("adult") override val adult: Boolean = false,
    @SerialName("backdrop_path") override val backdrop: String? = null,
    @PrimaryKey @SerialName("id") override val id: Int,
    @SerialName("title") override val name: String = "",
    @SerialName("overview") override val overview: String = "",
    @SerialName("poster_path") override val streamIcon: String? = null,
    @SerialName("popularity") override val popularity: Float? = null,
    @SerialName("release_date") override val releaseDate: String = "",
    @SerialName("vote_average") override val voteAverage: Double? = null,
    override val streamId: Int = -1
) : BaseTrending{
    @Transient @Ignore  override val added: String = ""
    @Transient @Ignore override val type: StreamType = StreamType.BACKDROP
    @Transient @Ignore override val streamType: String = ""
    @Transient @Ignore override val isAdult: Int=-1
    @Transient @Ignore override val categoryId: Int? =null
    @Transient @Ignore override val customSid: String? =null
    @Transient @Ignore override val directSource: String? =null
    @Transient @Ignore override val num: Int? =null
}

// 3. TrendingTvShow has its own serialization
@kotlinx.serialization.Serializable
@Entity(tableName = "TrendingTvShows")

data class TrendingTvShow(
    @SerialName("adult") override val adult: Boolean = false,
    @SerialName("backdrop_path") override val backdrop: String? = null,
    @PrimaryKey @SerialName("id") override val id: Int,
    @SerialName("name") override val name: String = "",
    @SerialName("overview") override val overview: String = "",
    @SerialName("poster_path") override val streamIcon: String? = null,
    @SerialName("popularity") override val popularity: Float? = null,
    @SerialName("first_air_date") override val releaseDate: String = "",
    @SerialName("vote_average") override val voteAverage: Double? = null,
    override val streamId: Int = -1
) : BaseTrending{
    @Transient @Ignore  override val added: String = ""
    @Transient @Ignore override val type: StreamType = StreamType.BACKDROP
    @Transient @Ignore override val streamType: String = ""
    @Transient @Ignore override val isAdult: Int=-1
    @Transient @Ignore override val categoryId: Int? =null
    @Transient @Ignore override val customSid: String? =null
    @Transient @Ignore override val directSource: String? =null
    @Transient @Ignore override val num: Int? =null
}
